import React from 'react';

const dateTimeFormat = new Intl.DateTimeFormat('es-ES', {
    day: '2-digit', month: '2-digit', year: 'numeric', hour: '2-digit', minute: '2-digit', timeZone: 'Europe/Madrid',
});

export default function InvoiceDateTime({ value }) {
    const date = value ? new Date(value) : null;
    return date && !Number.isNaN(date.getTime())
        ? <time dateTime={value} title="Hora de Madrid">{dateTimeFormat.format(date)}</time> : 'No disponible';
}
